<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M6.70001 18H4.15002C2.72002 18 2 17.28 2 15.85V4.15002C2 2.72002 2.72002 2 4.15002 2H8.45001C9.88001 2 10.6 2.72002 10.6 4.15002V6" stroke="url(#paint0_linear_2498_20215)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M17.3702 8.41998V19.58C17.3702 21.19 16.5702 22 14.9602 22H9.12018C7.51018 22 6.7002 21.19 6.7002 19.58V8.41998C6.7002 6.80998 7.51018 6 9.12018 6H14.9602C16.5702 6 17.3702 6.80998 17.3702 8.41998Z" stroke="url(#paint1_linear_2498_20215)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.3999 6V4.15002C13.3999 2.72002 14.1199 2 15.5499 2H19.8499C21.2799 2 21.9999 2.72002 21.9999 4.15002V15.85C21.9999 17.28 21.2799 18 19.8499 18H17.3699" stroke="url(#paint2_linear_2498_20215)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 11H14" stroke="url(#paint3_linear_2498_20215)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 14H14" stroke="url(#paint4_linear_2498_20215)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 22V19" stroke="url(#paint5_linear_2498_20215)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <defs>
    <linearGradient id="paint0_linear_2498_20215" x1="12.3978" y1="-17.0063" x2="29.7016" y2="4.75395" gradientUnits="userSpaceOnUse">
      <stop stop-color="#6782F6"/>
      <stop offset="1" stop-color="#41DEBD"/>
    </linearGradient>
    <linearGradient id="paint1_linear_2498_20215" x1="19.6008" y1="-13.0063" x2="35.7378" y2="12.1712" gradientUnits="userSpaceOnUse">
      <stop stop-color="#6782F6"/>
      <stop offset="1" stop-color="#41DEBD"/>
    </linearGradient>
    <linearGradient id="paint2_linear_2498_20215" x1="23.7977" y1="-17.0063" x2="41.1015" y2="4.75395" gradientUnits="userSpaceOnUse">
      <stop stop-color="#6782F6"/>
      <stop offset="1" stop-color="#41DEBD"/>
    </linearGradient>
    <linearGradient id="paint3_linear_2498_20215" x1="14.8362" y1="9.81211" x2="15.0707" y2="12.0071" gradientUnits="userSpaceOnUse">
      <stop stop-color="#6782F6"/>
      <stop offset="1" stop-color="#41DEBD"/>
    </linearGradient>
    <linearGradient id="paint4_linear_2498_20215" x1="14.8362" y1="12.8121" x2="15.0707" y2="15.0071" gradientUnits="userSpaceOnUse">
      <stop stop-color="#6782F6"/>
      <stop offset="1" stop-color="#41DEBD"/>
    </linearGradient>
    <linearGradient id="paint5_linear_2498_20215" x1="13.2091" y1="15.4363" x2="16.4387" y2="17.9551" gradientUnits="userSpaceOnUse">
      <stop stop-color="#6782F6"/>
      <stop offset="1" stop-color="#41DEBD"/>
    </linearGradient>
  </defs>
</svg>
  </template>